var map = {
	"./button-secondary-hover.png": 49,
	"./button-secondary-hover@2x.png": 50
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;


//////////////////
// WEBPACK FOOTER
// ./img/btn ^\.\/button\-secondary\-hover.*\.png$
// module id = 108
// module chunks = d-game